import { ReactElement, useEffect, useMemo } from 'react';
import { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { Page, StyledTabs } from '@ohpen/enso-ui';
import { FeesTab, FeeProfilesTab, FEES_VALUE_LIST_NAMES, getFeeOptions } from '@pmp/components';

import styles from './styles.module.css';
import { usePmpFetch, useListTabParam } from '@pmp/hooks';
import { useValueListsStore } from '@pmp/stores';

export const FeesPage = (): ReactElement => {
  const [isFetching, , fees, , fetchFees] = usePmpFetch('feeDefinitionsGetAllFeeDefinitions');
  const { valueLists, getValueLists } = useValueListsStore();
  const { t } = useTranslation();

  useEffect(() => {
    getValueLists({ fetchIfMissing: FEES_VALUE_LIST_NAMES });
  }, [getValueLists]);

  useEffect(() => {
    fetchFees();
  }, [fetchFees]);

  const tabItems: TabsProps['items'] = useMemo(() => {
    const feeProfilesValueLists = { ...valueLists, FEES: fees ? getFeeOptions(fees) : {} };
    const items = [
      {
        key: 'fees',
        label: t('pmp.fees.labels.feesList'),
        children: <FeesTab valueLists={valueLists} data={fees} isFetching={isFetching} fetchData={fetchFees} />,
      },
      {
        key: 'profiles',
        label: t('pmp.fees.labels.feeProfiles'),
        children: <FeeProfilesTab valueLists={feeProfilesValueLists} />,
      },
    ];

    return items;
  }, [valueLists, fees, t, isFetching, fetchFees]);

  const tabKeys = useMemo(() => (tabItems ?? []).map(item => String(item.key)), [tabItems]);
  const tabParam = useListTabParam(tabKeys);

  return (
    <Page>
      <Page.Title>{t('pmp.fees.title')}</Page.Title>
      <Page.Content>
        <StyledTabs {...tabParam} items={tabItems} className={styles.tabs} />
      </Page.Content>
    </Page>
  );
};
